import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const textAreaV3Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate text area element to v3 by adding default container.overflow',
  run: (_props: PartialPropsOf<'textArea'>): void => {
    // we tried changing default overflow to 'hidden' while keeping current behavior
    // with this migration. it turned out that without handling proj. styles the existing
    // text widgets got broken
  },
};
